import React, { useState } from "react";
import * as api from '../../api/index';
import useExternalClickHandler from "../../hooks/useExternalClickHandler";

let arrayOfVideoIds = [];

/**
 * Renders a video with reaction buttons.
 * @param {Object} props The component properties.
 * @param {string} props._id The video id.
 * @param {string} props.title The video title.
 * @param {string} props.description The video description.
 * @param {string} props.url The video url.
 * @param {any[]} props.reactions
 * @returns {import("react").ReactNode}
 */
export default function Video({_id, title, description, url, reactions, hideTitle = false}) {
    const [currentReaction, setReaction] = useState(reactions.find(r => r.userId === JSON.parse(localStorage.getItem("profile")).id)?.reaction);
    const headingText = description && description.trim() ? description : title;

    /**
     * @param {"like" | "dislike"} reaction 
     */
    function handleReaction(reaction) {
        const newReaction = currentReaction === reaction ? null : reaction;
        setReaction(newReaction);

 
        // TODO: Send request to server using id.
        api.setVideoReaction(_id, newReaction);

        //edited feedback
        



    }

    useExternalClickHandler((el) => {
        if (!arrayOfVideoIds.includes(el.getAttribute("data-id"))){
            api.incrementViewCount(el.getAttribute("data-id"));
            arrayOfVideoIds.push(el.getAttribute("data-id"));
        }
    });

    return (
        <div className="col-md-6 mb-4">
            <div className="card video-card">
                <div className="card-body">
                {!hideTitle && <h2 className="card-title h3">{headingText}</h2>}
<div className="video-section mb-4">
  {/* title already used as fallback above, so remove <h3> */}

                        <div className="ratio ratio-16x9">
                            <iframe
                                src={url}
                                title={title}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                data-id={_id}
                            ></iframe>
                        </div>
                        <div className="feedback mt-2">
                            <ReactionButton
                                type="like"
                                isActive={currentReaction === "like"}
                                onClick={() => handleReaction("like")}
                            />
                            <ReactionButton
                                type="dislike"
                                isActive={currentReaction === "dislike"}
                                onClick={() => handleReaction("dislike")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

/**
 * Button for reactions (Like/Dislike)
 * @param {Object} props
 * @param {"like" | "dislike"} props.type The button type.
 * @param {boolean} props.isActive Whether the button is active.
 * @param {Function} props.onClick The click event handler.
 */
function ReactionButton({ type, isActive, onClick }) {
    const label = type == "like" ? "Like video" : "Dislike video";
    return (
        <button
            className={`reaction-btn ${type} ${isActive ? "active" : ""}`}
            onClick={onClick}
            aria-pressed={isActive}
            aria-label={label}
        >

            <img 
            src={type== "like" ? "images/thumBsup.png" : "/images/thumBsdown.png"}
                alt=""
                className="reaction-icon"
                />
            
            
            
        </button>
    );
}
